export default "__VITE_ASSET__cUmB9XA6__"